import React, { FunctionComponent, useCallback } from 'react'
import { ContainerCards, Divider } from './styles'
import { Card, CardContent, Grid } from '@material-ui/core'
import { Title } from '../../../Pagamento/styles'
import ItemServicoFinanceiro from './components/ItemServicoFinanceiro'
import IconExtrato from '../../../../../../shared/components/Icons/IconExtrato'
import IconTransferenciBancaria from '../../../../../../shared/components/Icons/IconTransferenciaBancaria'
import IconPorcentagemTransferencia from '../../../../../../shared/components/Icons/IconPorcentagemTransferencia'
import IconDepositoBoleto from '../../../../../../shared/components/Icons/IconDepositoBoleto'
import IconPagamentoBoleto from '../../../../../../shared/components/Icons/IconPagamentoBoleto'
import { useHistory } from 'react-router-dom'
import PagamentoRoutes from '../../../../utils/PagamentoRoutes'
import { useCartao } from '../../../../hooks/useCartao'
import { isValidValue } from '../../../../../../shared/utils/validates'

const ListServicoFinanceiro: FunctionComponent = () => {
  const history = useHistory()
  const { cartao } = useCartao()
  const irParaPagina = useCallback((pagina: string) => {
    history.replace(pagina)
  }, [])

  return (
    <ContainerCards>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card
            variant={'outlined'}
            style={{
              padding: 8,
            }}
          >
            <CardContent
              style={{
                minHeight: '60vh',
                marginRight: 16,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Title
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    Pagamentos
                  </Title>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                {/* <Grid item sm={4}> */}
                {/*  <ItemServicoFinanceiro */}
                {/*    title={'Tag Pedágio'} */}
                {/*    subtitle={'Gerencie suas Tags'} */}
                {/*    icon={<IconTransferenciBancaria size={20} />} */}
                {/*    onClick={() => alert('clicado')} */}
                {/*    isNew={true} */}
                {/*  /> */}
                {/* </Grid> */}
                <Grid item xs={4}>
                  <ItemServicoFinanceiro
                    title={'Transferência'}
                    subtitle={`Pagamento creditado no mesmo dia apenas para mesma titularidade`}
                    icon={<IconTransferenciBancaria size={17} />}
                    onClick={() =>
                      isValidValue(cartao) &&
                      irParaPagina(PagamentoRoutes.TRANSFERENCIA)
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <ItemServicoFinanceiro
                    title={'Extrato'}
                    subtitle={
                      'Veja as transações de recebimentos e transferências realizadas.'
                    }
                    icon={<IconExtrato size={17} />}
                    onClick={() =>
                      isValidValue(cartao) &&
                      irParaPagina(PagamentoRoutes.EXTRATO)
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <ItemServicoFinanceiro
                    title={'% de transferência'}
                    subtitle={'Ajuste os parâmetros financeiros da sua conta.'}
                    icon={<IconPorcentagemTransferencia size={17} />}
                    onClick={() =>
                      isValidValue(cartao) &&
                      irParaPagina(PagamentoRoutes.PORCENTAGEM_TRANSFERENCIA)
                    }
                  />
                </Grid>
                <Grid item xs={4}>
                  <ItemServicoFinanceiro
                    title={'Trazer dinheiro'}
                    subtitle={
                      'Veja as transações de recebimentos e transferências realizadas.'
                    }
                    icon={<IconDepositoBoleto size={17} />}
                    onClick={() =>
                      irParaPagina(PagamentoRoutes.TRAZER_DINHEIRO)
                    }
                    isNew={true}
                  />
                </Grid>
                <Grid item xs={4}>
                  <ItemServicoFinanceiro
                    title={'Pagamento'}
                    subtitle={'Pague seus boletos de forma simplificada'}
                    icon={<IconPagamentoBoleto size={17} />}
                    onClick={() =>
                      isValidValue(cartao) &&
                      irParaPagina(PagamentoRoutes.PAGAMENTO_BOLETO)
                    }
                    isNew={true}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </ContainerCards>
  )
}

export default ListServicoFinanceiro
